
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-1b2cfd7a&scoped=true!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Comment.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Comment.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-1b2cfd7a!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Comment.vue"),
  /* scopeId */
  "data-v-1b2cfd7a",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Comment.vue
// module id = 366
// module chunks = 0